import {Plugin, registerPlugin} from "./Plugin";
import {whenReady} from "../utils";
import {initDataClickSource} from "../components/DataClickSource";

export class DataClickSourcePlugin extends Plugin {
    public init(element: Element) {
        if (element instanceof HTMLElement && element.hasAttribute("data-click-source")) {
            initDataClickSource(element);
        }
    }
}

whenReady(() => {
    registerPlugin(DataClickSourcePlugin);
});